import styled, { css } from 'styled-components'

import theme from 'live/services/theme'

export const Caret = styled.i`
    font-size: 14px;
    color: ${theme.info};
    margin-left: 5px;
`

export const Button = styled.button`
    display: flex;
    align-items: center;
    height: 32px;
    padding: 0 20px;

    border: none;
    margin: 0;
    width: auto;
    overflow: visible;
    background: transparent;
    text-align: inherit;
    :focus {
        outline-color: ${theme['link-button']};
    }

    /* inherit font & color from ancestor */
    color: inherit;
    font: inherit;

    /* Normalize line-height. Cannot be changed from normal in Firefox 4+. */
    line-height: normal;

    /* Corrects font smoothing for webkit */
    -webkit-font-smoothing: inherit;
    -moz-osx-font-smoothing: inherit;

    /* Corrects inability to style clickable input types in iOS */
    -webkit-appearance: none;

    /* Remove excess padding and border in Firefox 4+ */
    &::-moz-focus-inner {
        border: 0;
        padding: 0 20px;
    }
`

export const DropdownMenu = styled.ul`
    position: absolute;
    z-index: 1;
    cursor: pointer;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    background-color: ${({ theme }) => theme['gray-0']};
    border-radius: 3px;
    min-width: 136px;
    border: 1px solid ${theme['input-borders']};
    padding: 17px 20px;
    box-shadow: 0 1px 5px 0 rgba(96, 106, 128, 0.25);
    ${props =>
        props.open
            ? css`
                  display: block;
              `
            : css`
                  display: none;
              `};
`

export const DropdownMenuItem = styled.li`
    &:not(:first-child) {
        margin-top: 7px;
    }
`

export const Dropdown = styled.div`
    position: relative;
    z-index: 15;
`

export const StyledButton = styled(Button)`
    position: relative;
    z-index: 11;
    outline: 0;
`

export const StyledDropdownMenu = styled(DropdownMenu)`
    z-index: 10;
    white-space: pre;
    padding-bottom: 5px;
    padding-left: 0;
    padding-right: 0;
`

export const StyledDropdownMenuItem = styled(DropdownMenuItem)`
    font-size: 14px;
    color: ${({ theme }): string => theme['brand-primary']};
    display: flex;

    &:hover {
        background-color: ${({ theme }): string => theme['gray-lighter']};
    }

    > span {
        flex-shrink: 0;
        flex-basis: 22px;
        text-align: center;
    }

    > div {
        flex: 1;
    }

    &:not(:first-child) {
        margin-top: 0px;
    }
`

export const StyledCaret = styled(Caret)`
    padding-top: 6px;
    ${({ disabled }: { disabled: boolean }) =>
        disabled
            ? css`
                  color: ${({ theme }) => theme['input-borders']};
              `
            : ''}
`
